const faqs = [
  {
    q: '51每日大赛是什么？',
    a: '51每日大赛是一个专注于娱乐八卦与争议事件聚合的资讯平台，每日精选全网最热吃瓜内容，涵盖明星塌房、综艺争议、网红翻车、影视吐槽等热门话题。我们致力于为吃瓜爱好者提供最新、最全、最真实的娱乐爆料资讯。',
  },
  {
    q: '爆料信息来源可靠吗？',
    a: '我们采用多源交叉验证机制，每条爆料均标注信息来源，并对关键信息进行多方核实。对于未经证实的传闻，我们会明确标注"待考证"标签，让读者自行判断可信度。我们坚持不造谣、不信谣、不传谣的原则。',
  },
  {
    q: '如何投稿爆料？',
    a: '你可以通过页底的"投稿爆料"入口联系我们。我们欢迎圈内人士和知情者提供真实爆料线索。所有投稿均支持匿名提交，我们严格保护爆料人的隐私安全，不会向任何第三方透露投稿人信息。',
  },
  {
    q: '平台更新频率如何？',
    a: '51每日大赛保持全天候更新，编辑团队7×24小时追踪最新娱乐动态。每日更新超过200条爆料内容，重大突发事件15分钟内完成首发报道，确保你永远能第一时间吃到最新鲜的瓜。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于51每日大赛，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 md:p-6">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-7">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}